import {Component, Input, Output, EventEmitter, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MenuItemGroup, Store} from '../../models/store';
import {bestListThumbnail} from '../../models/order';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-menu-group-items',
  templateUrl: './menu-group-items.component.html',
  styleUrls: ['./menu-group-items.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuGroupItemsComponent implements OnInit {

  @Input() store: Store;
  @Input() orderId: string;
  @Input() item: any;
  @Input() uiSetting: any;
  @Input() isCatering: boolean = false;
  /**
   * 'grid' = image-first card (placeholder when no photo) — what the parent passes for every store.
   * 'list' = compact row, the default kept only so this component works standalone.
   */
  @Input() layout: 'list' | 'grid' = 'list';

  get isGrid(): boolean {
    return this.layout === 'grid';
  }
  @Output() itemSelected = new EventEmitter<any>();
  /** "+" tapped: parent adds straight to the order when the item needs no choices, else opens options. */
  @Output() quickAdd = new EventEmitter<any>();
  /** Parent flips this while an add is in flight so the button can show a spinner. */
  @Input() adding = false;
  /** How many of this item are already in the order — the "+" turns into a brand badge with the count. */
  @Input() inCart = 0;

  isVisible = true;
  descExpanded = false;
  imageLoaded = false;
  imageFailed = false;

  /** Newest list-sized photo, or null. */
  get thumbnail(): string | null {
    return bestListThumbnail(this.item?.last_image);
  }

  onImageLoad() {
    this.imageLoaded = true;
  }

  /** A missing object in the bucket should degrade to the initials tile, not an empty box. */
  onImageError() {
    this.imageFailed = true;
  }

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
  }

  onSelect() {
    this.itemSelected.emit(this.item);
  }

  onQuickAdd(event: Event) {
    event.stopPropagation();
    if (this.adding) return;
    this.quickAdd.emit(this.item);
  }

  public santize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
}
